<template>
  <div>
    <div
      v-if="accommodatie"
      class="hidden lg:block xl:block shadow-md mt-6 mr-2"
    >
      <div class="tab w-full m-0">
        <input
          class="absolute opacity-0"
          id="tab-multi-one"
          type="checkbox"
          name="tabs"
        />
        <label
          class="block pl-2 pb-2 bg-gray-100 text-gray-700 cursor-pointer"
          for="tab-multi-one"
          >Sportcomplex</label
        >
        <div
          class="tab-content overflow-hidden border-b bg-gray-200 text-gray-700 border-white pl-12"
          @click="openSportcomplex(accommodatie.id)"
          :class="{ 'text-mi-blue-500 font-bold': $route.name=='Sportcomplex'}"
        >
          <p class="pl-3">
            <a href="#">Accommodaties in sportcomplex</a>
          </p>
        </div>
      </div>

      <div class="tab w-full m-0">
        <input
          class="absolute opacity-0"
          id="tab-multi-two"
          type="checkbox"
          name="tabs"
          checked
        />
        <label
          class="block pl-2 pb-2 bg-gray-100 text-gray-700 cursor-pointer"
          for="tab-multi-two"
          >Accommodatie</label
        >
        <div
          class="tab-content overflow-hidden border-b bg-gray-200 text-gray-700 border-white pl-12 cursor-pointer"
          @click="openAccomm(accommodatie.id)"
          :class="{ 'text-mi-blue-500 font-bold': $route.name=='Accommodatie'}"
        >
          <p 
            class="pl-3"
            >
            Algemene informatie
          </p>
        </div>
        <div
          class="tab-content overflow-hidden border-b bg-gray-200 text-gray-700 border-white pl-12 cursor-pointer"
          @click="openMoveSportcomplex(accommodatie.id)"
          v-if="hasPermission('update accommodatie')"  
          :class="{ 'text-mi-blue-500 font-bold': $route.name=='MoveToSportcomplex'}"
        >
          <p class="pl-3"
          >Verplaats naar ander sportcomplex</p>
        </div>
      </div>

      <div class="tab w-full m-0">
        <input
          class="absolute opacity-0"
          id="tab-multi-three"
          type="checkbox"
          name="tabs"
          v-model="checkedVz"
        />
        <label
          class="block pl-2 pb-2 bg-gray-100 text-gray-700 cursor-pointer"
          for="tab-multi-three"
          v-if="hasPermission('read voorziening')"
          >Voorzieningen ({{ voorzieningen.length }})</label
        >

        <div
          class="tab-content overflow-hidden border-b bg-gray-200 text-gray-700 border-white pl-12"
        >
          <div class="relative mr-2">
            <div
              class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
            >
              <svg
                class="fill-current h-4 w-4"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
              >
                <path
                  d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                />
              </svg>
            </div>
          </div>
        </div>

        <div
          v-for="(vz, index) in voorzieningen"
          :key="index"
          @click="openVz(accommodatie.id, vz.id)"
          class="tab-content overflow-hidden bg-gray-200 text-gray-700 border-white pl-12 cursor-pointer"
        >
          <div
            class="pl-3"
            v-if="hasPermission('read voorziening')"
            :class="{ 'text-mi-blue-500 font-bold': vz.id==current_voorziening_id }"
          >
            Voorziening
            {{ vz.id.substr(0,5) }}

            <div class="text-xs text-gray-500 font-normal pl-3 truncate">
              <i
                class="material-icons float-right pr-2"
                v-if="vz.geometrie"
                title="Deze voorziening heeft geometrie"
                >public</i
              >
              <p>{{ vz.ondergrond.naam }} | {{ vz.voorziening_type.naam }}</p>

              <span v-for="sport in vz.sporten" v-bind:key="sport.code">
                {{ sport.naam }}
              </span>
            </div>
          </div>
        </div>
        <div
          @click="openAddVz(accommodatie.id)"
          class="tab-content overflow-hidden bg-mi-blue-400 text-gray-100 border-white pl-12 cursor-pointer hover:bg-mi-blue-500 "
          v-if="hasPermission('create voorziening')"
        >
          <div class="pl-3">
            <span class=" align-middle">
              <i class="material-icons md-3xl  p-1 ">add_circle_outline</i>
            </span>
            <span class=" align-middle pb-3">
              Voorziening
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- Mobile card -->

    <div v-if="accommodatie" class="lg:hidden xl:hidden bg-gray-100">
      <div>
        <p
          class="lg:hidden xl:hidden font-raleway font-bold text-xl ml-2 text-mi-blue-500 uppercase"
        >
          Sportcomplex
        </p>
      </div>
      <div class="grid grid-cols-2 gap-2 mx-2 mb-4">
        <div
          @click="openSportcomplex(accommodatie.id)"
          class="border-b bg-gray-200 text-gray-700 border-white cursor-pointer rounded-lg shadow-sm"
        >
          <div>
            <p
              class="text-center bg-gray-400 rounded-t-lg truncate capitalize font-bold"
            >
              Sportcomplex
            </p>
            <p class="text-xs text-gray-500 bg-gray-200 pl-3 truncate">
              Accommodaties in sportcomplex
            </p>
          </div>
        </div>
      </div>
      <div>
        <p
          class="lg:hidden xl:hidden font-raleway font-bold text-xl ml-2 text-mi-blue-500 uppercase"
        >
          Accommodatie
        </p>
      </div>
      <div class="grid grid-cols-2 gap-2 mx-2 mb-4">
        <div
          @click="openAccomm(accommodatie.id)"
          class="border-b bg-gray-200 text-gray-700 border-white cursor-pointer rounded-lg shadow-sm"
        >
          <div>
            <p
              class="text-center bg-gray-400 rounded-t-lg truncate capitalize font-bold"
            >
              {{ accommodatie.naam }}
            </p>
            <p class="text-xs text-gray-500 pl-3 truncate">
              Algemene informatie
            </p>
          </div>
        </div>
        <div
          @click="openMoveSportcomplex(accommodatie.id)"
          class="border-b bg-gray-200 text-gray-700 border-white cursor-pointer rounded-lg shadow-sm"
          v-if="hasPermission('update accommodatie')"
        >
          <div>
            <p
              class="text-center bg-gray-400 rounded-t-lg truncate capitalize font-bold"
            >
              Verplaatsen
            </p>
            <p class="text-xs text-gray-500 pl-3 truncate"
            >
              Verplaats naar ander sportcomplex
            </p>
          </div>
        </div>
      </div>
      <div v-if="hasPermission('read voorziening')">
        <p
          class="lg:hidden xl:hidden font-raleway font-bold text-xl ml-2 text-mi-blue-500 uppercase"
        >
          Voorzieningen
        </p>
      </div>
      <div
        class="grid grid-cols-2 gap-2 mx-2"
        v-if="hasPermission('read voorziening')"
      >
        <div
          v-for="(vz, index) in voorzieningen"
          :key="index"
          @click="openVz(accommodatie.id, vz.id)"
          class="border-b bg-gray-200 text-gray-700 border-white cursor-pointer rounded-lg shadow-sm"
        >
          <div>
            <p
              class="text-center bg-gray-400 rounded-t-lg capitalize font-bold"
              :class="{ 'text-mi-blue-500': vz.active }"
            >
              Voorziening {{ vz.id.substr(0,5) }} 
            </p>
            
            <p class="text-xs text-gray-500 pl-3 truncate">
              <span v-for="sport in vz.sporten" v-bind:key="sport.code"
                >{{ sport.naam }}
              </span>
            </p>
          </div>
        </div>
        <div
          @click="openAddVz(accommodatie.id)"
          class="border-b bg-gray-200 text-gray-700 border-white cursor-pointer rounded-lg shadow-sm"
        >
          <div>
            <p
              class="text-center bg-gray-400 rounded-t-lg capitalize font-bold"
            >
              Voorziening toevoegen
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "RightNavPane",
  data: function() {
    return {
      checkedVz: this.$route.name === "Voorziening",      
      current_voorziening_id: this.$router.currentRoute.params.vzid
    };
  },
  watch: {
    $route() {
      // react to route changes...
      this.checkedVz = this.$route.name === "Voorziening";
      this.current_voorziening_id = this.$router.currentRoute.params.vzid;
    }
  },
  computed: {
    voorzieningen: function() {      
      const voorzieningen = this.voorzieningen_cache.filter(
        vz => vz.accommodatie.id === this.accommodatie.id
      );
      return this.sortVoorzieningen(voorzieningen);
    },
    ...mapState({
      accommodatie: state => state.backend_data.current_accommodatie,
      voorzieningen_cache: state => state.backend_data.voorzieningen
    })
  },
  methods: {
    sortVoorzieningen: function(voorzieningen) {
      const getFirstSport = (sporten) =>{
        return sporten.map(sport => sport.naam).sort().shift();
      };
      return voorzieningen.sort((vz1, vz2) => {
        let result = getFirstSport(vz1.sporten).localeCompare(getFirstSport(vz2.sporten));
        if (result !== 0) return result;
        result = vz1.voorziening_type.naam.localeCompare(vz2.voorziening_type.naam);
        if (result !== 0) return result;
        return vz1.ondergrond.naam.localeCompare(vz2.ondergrond.naam);
      })
    },
    openAccomm: function(id) {
      this.$emit("showAccommComp");
      if (this.$router.currentRoute.name !== "Accommodatie")
        this.$router.push({ name: "Accommodatie", params: { id: id } });
    },
    openSportcomplex: function(id) {
      this.$emit("showAccommComp");
      if (this.$router.currentRoute.name !== "Sportcomplex")
        this.$router.push({ name: "Sportcomplex", params: { id: id } });
    },
    openVz: function(id, vzid) {
      this.$emit("showAccommComp");
      if (this.$router.currentRoute.params.vzid !== vzid)
        this.$router.push({
          name: "Voorziening",
          params: { id: id, vzid: vzid }
        });
    },
    openAddVz: function(id) {
      this.$emit("showAccommComp");

      this.$router.push({
        name: "AddVoorziening",
        params: { id: id }
      });
    },
    openMoveSportcomplex: function(id) {
      this.$emit("showAccommComp");
      this.$router.push({
        name: "MoveToSportcomplex",
        params: { id: id }
      });
    }
  }
};
</script>

<style>
/* Tab content - closed */
.tab-content {
  max-height: 0;
}
/* :checked - resize to full height */
.tab input:checked ~ .tab-content {
  max-height: 100vh;
  @apply border-b border-white;
}
.tab label::after {
  float: left;
  margin-right: 0.5em;
  top: 0;
  display: block;
  width: 1.5em;
  height: 1.5em;
  line-height: 1.5;
  font-size: 1.25rem;
  text-align: center;
  -webkit-transition: all 0.5s;
  -o-transition: all 0.5s;
  transition: all 0.5s;
}
.tab input[type="checkbox"] + label::after {
  transform: rotate(-90deg);
  content: "\25BE";
  font-weight: bold; /*.font-bold*/
}
.tab input[type="checkbox"]:checked + label::after {
  color: #7c0040;
  transform: rotate(0deg);
}

</style>
